import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, skip, pairwise,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

Dispatch.getAction('Instance', 'create')
  .pipe(
    map(e => true),
    merge(Dispatch.getState('States')
      .pipe(
        skip(1), 
        map(e => false)
      )
    )
  )
  .subscribe(e => Dispatch.nextState('StateBuffer', e))

Dispatch.getState('dragTarget')
  .pipe(
    // tap(e => console.log("adsf")),
    // tap(e => console.log(e)),
    filter(e => e.type === 'tagInput'),
    filter(e => e.id === 'input'),
    filter(e => e.inputType === 'file'),
  )
  .subscribe(e => Dispatch.mergeState('dragTarget', { accept: true }))